import React from 'react';
import {
  colors,
  NewTypography as Typography,
  useViewport,
} from '@lamimed/pantheon';

import { SectionWrapper } from 'components/wrappers/SectionWrapper';

import { NextSectionButton } from '../NextSectionButton';

import { valuesIcons } from './data';

import * as S from './styles';

interface Value {
  icon: string;
  title: string;
  description: string;
}

interface Props {
  values: Value[];
}

export const Values: React.FC<Props> = ({ values }) => {
  const { greaterThan } = useViewport();

  return (
    <SectionWrapper backgroundColor="neutral_extra_light" id="values-section">
      <S.Wrapper>
        <Typography variant="heading_2" as="h2" marginBottom="small">
          La nostra missione e i nostri valori
        </Typography>

        <Typography marginBottom="small">
          Rendere la medicina primaria accessibile a tutti.
        </Typography>

        <Typography marginBottom="medium">
          In Lami crediamo fortemente che la salute possa essere resa semplice
          attraverso la combinazione di fattore umano, scienza e tecnologia.
        </Typography>

        <S.Row>
          {values.map((value) => (
            <S.Column key={`value-${value.icon}`}>
              <S.Title>
                {React.createElement(
                  valuesIcons[value.icon as keyof typeof valuesIcons],
                  {
                    width: greaterThan('tablet') ? 30 : 24,
                    height: greaterThan('tablet') ? 30 : 24,
                    color: colors.dark,
                  },
                )}

                <Typography
                  variant="heading_4"
                  marginTop="none"
                  marginBottom="none"
                >
                  {value.title}
                </Typography>
              </S.Title>

              <S.Content>
                <Typography variant="body_text_3" marginBottom="none">
                  {value.description}
                </Typography>
              </S.Content>
            </S.Column>
          ))}
        </S.Row>
      </S.Wrapper>

      <NextSectionButton nextSectionId="scientific-comitee" />
    </SectionWrapper>
  );
};

export default Values;
